import CardVM from './card-vm';

export default function(courseId, courseworkId, layoutMode, browsingScope, userType) {
  let self = this;

  self.mobileBreakPoint = 768;
  self.$window = $(window);
  self.windowWidth = ko.observable(self.$window.width());
  self.mobileView = ko.computed(function () {
    return self.windowWidth() < self.mobileBreakPoint;
  });
  self.mobileView.subscribe(function () {
    self.currentView('grid');
  });
  self.layoutMode = ko.observable();
  self.browsingScope = ko.observable();
  self.userType = ko.observable();
  self.publicView = ko.computed(function () {
    return self.userType() === 'public';
  });
  self.searchEnabled = ko.observable(false);
  self.searchApplied = ko.computed(function () {
    return self.searchEnabled() && !_.isEmpty(self.params.search());
  });

  var sortArrayValues = [
    Kadenze.I18n.t('course.gallery.sort_options.latest'),
    Kadenze.I18n.t('course.gallery.sort_options.oldest'),
    Kadenze.I18n.t('course.gallery.sort_options.most_comments'),
    Kadenze.I18n.t('course.gallery.sort_options.least_comments')
  ];

  self.sortOptions = ko.observableArray(sortArrayValues);
  self.fileTypes = ko.observableArray();
  self.courses = ko.observableArray();
  self.courseworks = ko.observableArray();
  self.currentView = ko.observable('grid'); //or 'table'
  self.currentView.subscribe(function (value) {
    self.currentPage(1);
    setTimeout(self.loadCourseworkEntries, 100);
  });
  self.courseworkEntries = ko.observableArray();
  self.courseworkEntriesMeta = ko.observable();
  self.courseworkEntriesLoading = ko.observable(false);
  self.currentPage = ko.observable(1);
  self.paginator = ko.observable();
  self.params = {
    course: ko.observable(),
    category_ids: ko.observableArray([]),
    coursework: ko.observable(),
    types: ko.observableArray([]), //TODO: Use multiple types across the board
    typesMultiple: ko.observableArray([]),
    sort: ko.observable('latest'),
    search: ko.observable(),
    featured: ko.observable()
  };
  self.courseId = ko.computed(function () {
    return self.params.course() && self.params.course().slug() || courseId;
  });
  self.courseworkId = ko.computed(function () {
    return self.params.coursework() && self.params.coursework().slug() || courseworkId;
  });
  self.placeholder = {
    visible: ko.observable(false),
    type: ko.observable('no_results') //or 'loading'
  };

  self.showPlaceholder = function (type) {
    this.placeholder.type(type);
    this.placeholder.visible(true);
  };

  self.hidePlaceholder = function () {
    this.placeholder.visible(false);
  };

  self.initSearchEvents = function() {
    let $el = self.mobileView() ? $('#searchPeerCourseworkMobile') : $('#searchPeerCoursework');
    $el.off('blur').on('blur', function () {
      if(_.isEmpty(self.params.search())) {
        self.searchEnabled(false);
      }
    });
  };

  self.loadMoreEvent = function () {
    $(window).off('scroll.galleryLoadMore').on('scroll.galleryLoadMore', function() {
      let elementId = '.js-loadmore',
        elTopOffset = $(elementId).offset().top,
        elOuterHeight = $(elementId).outerHeight(),
        windowHeight = $(window).height(),
        scrollTop = $(this).scrollTop();

      if(scrollTop > (elTopOffset + elOuterHeight - windowHeight)) {
        self.loadMore();
      }
    });

    $(document).on('pjax:start', function() {
      $(window).off('scroll.galleryLoadMore');
      $(document).off('pjax:start');
    });
  };

  self.showWelcomeModal = function () {
    if ((Kadenze.isKadenze) && self.publicView() && _.isEmpty($.cookie('GWMShown'))) {
      $('#gallery_overview_welcome_modal').modal('show');
      $.cookie('GWMShown', true, { expires: 365, path: '/' });
    }
  };

  self.initUI = function() {
    self.$window.resize(function(){
      self.windowWidth(self.$window.width());
    });
    self.initSearchEvents();
    self.initPaginationEvents();
    self.showWelcomeModal();
    if (self.layoutMode() == 'full' && self.currentView() == 'grid') {
      self.loadMoreEvent();
    } else {
      $(window).off('scroll.galleryLoadMore');
    }
  };

  self.bindFilters = function () {
    _.each(_.keys(self.params), function (key) {
      self.params[key].subscribe(self.filterChanged, self);
    });

    self.searchEnabled.subscribe(function (value) {
      if (value == false) {
        self.params.search('');
      }
    });
  };

  self.filterByType = function (type) {
    if (self.mobileView() && !_.include(self.params.typesMultiple(), type)) {
      self.params.typesMultiple.push(type);
    } else {
      self.params.types(type);
    }
  };

  self.fetchCourseworkEntries = _.memoize(function (url) {
    return new Kadenze.AjaxRequest({
      type: 'GET',
      url: url,
      dataAsJSON: false,
      timeout: 60000
    });
  });

  self.deleteRequestCache = function () {
    self.fetchCourseworkEntries.cache = {};
  };

  self.loadCourseworkEntries = function(append, url) {
    let mp = null;

    self.courseworkEntriesLoading(true);

    if ($('#coursework-overview .js-loader').length > 0) {
      mp = new Mprogress({
        template: 4,
        start: true,
        parent: '#coursework-overview .js-loader'
      });
    }

    url = url ? url : Kadenze.Routes.course_gallery_coursework_coursework_entries_path(
      self.courseId(),
      self.courseworkId(),
      {
        category_ids: self.params.category_ids(),
        types: self.params.types() || self.params.typesMultiple(),
        sort: self.sortOptions.indexOf(self.params.sort()),
        search: self.params.search(),
        page: self.currentPage(),
        browsing_scope: self.browsingScope(),
        featured: self.params.featured()
      }
    );

    let request = self.fetchCourseworkEntries(url);

    request.done(function(data) {
      let mapping = {
        'create': function(options) {
          return new CardVM({
            ...options.data,
            course_id: self.courseId(),
            coursework_id: self.courseworkId()
          }, self);
        }
      };

      let mapped_entries = ko.mapping.fromJS(data.coursework_entries, mapping);

      if (append) {
        ko.utils.arrayPushAll(self.courseworkEntries, mapped_entries());
      } else {
        self.courseworkEntries(mapped_entries());
      }
      self.courseworkEntriesMeta(ko.mapping.fromJS(data.meta));
      self.currentPage(self.courseworkEntriesMeta().current_page());
      self.paginator(self.courseworkEntriesMeta().paginator());

      if (self.courseworkEntries().length == 0) {
        self.showPlaceholder('no_results');
      } else {
        self.hidePlaceholder();
      }

      self.courseworkEntriesLoading(false);
    });

    request.error(function(data) {
      new Kadenze.Notice.error({ message: Kadenze.I18n.t('notice.unexpected_error') });
    });

    request.always(function () {
      if (mp != null) {
        mp.end();
      }

      self.initPaginationEvents();
    });
  };

  self.initPaginationEvents = function () {
    if (self.currentView() == 'table') {
      Kadenze.PaginationBinding.applyBindingsWithTextInput(self.pageChanged.bind(self));
    }
  };

  self.pageChanged = function (url) {
    self.loadCourseworkEntries(false, url);
  };

  self.updateTypes = function () {
    self.currentPage(1);
    if (browsingScope === 'course') {
      self.fileTypes(self.params.coursework() && self.params.coursework().file_types() || []);
    }
  };

  self.filterChanged = function () {
    self.updateTypes();
    self.loadCourseworkEntries();
    self.refreshURL();
  };

  self.showLoadMore = ko.computed(function () {
    return !self.placeholder.visible() && self.courseworkEntriesMeta() && self.courseworkEntriesMeta().next_page();
  });

  self.loadMore = function () {
    if (self.layoutMode() == 'full') {
      if (self.courseworkEntriesMeta() && self.courseworkEntriesMeta().next_page() && !self.courseworkEntriesLoading() && (self.currentView() == 'grid')) {
        self.currentPage(self.courseworkEntriesMeta().next_page());
        self.loadCourseworkEntries(true);
      }
    } else {
      Kadenze.Request.pjax({url: Kadenze.Routes.course_gallery_overview_path(self.courseId())});
    }
  };

  self.changeView = function (type) {
    self.currentView(type);
  };

  self.toggleView = function () {
    (self.currentView() == 'grid') ? self.changeView('table') : self.changeView('grid');
  };

  self.showSearch = function () {
    self.searchEnabled(true);
    let $el = self.mobileView() ? $('#searchPeerCourseworkMobile') : $('#searchPeerCoursework');
    $el.focus();
  };

  self.toggleSearch = function () {
    if( self.searchEnabled() ){
      self.searchEnabled(false);
    } else {
      self.searchEnabled(true);
      let $el = self.mobileView() ? $('#searchPeerCourseworkMobile') : $('#searchPeerCoursework');
      $el.focus();
    }
  };

  self.toggleMobileOptions = function () {
    $('#mobile_filter_options_modal').modal('toggle');
  };

  self.refreshURL = function () {
    if (self.params.coursework() && self.layoutMode() == 'full') {
      let url = Kadenze.Routes.course_gallery_coursework_overview_path(self.courseId(), self.courseworkId(), {
        types: self.params.types() || self.params.typesMultiple(),
        sort: self.sortOptions.indexOf(self.params.sort()),
        search: self.params.search(),
        featured: self.params.featured()
      });
      history.replaceState($.pjax.state, null, url);
    }
  };

  self.userInfoTooltipParams = function (user) {
    return {
      template: 'templates/tooltip-userinfo',
      templateParams: {
        full_name: user.full_name(),
        username: user.slug(),
        email: null,
        avatar: user.avatar(),
        profile_path: user.profile_path(),
        message_path: user.message_path()
      },
      position: 'top',
      showDelay: .7
    };
  };

  self.interceptURLParams = function() {
    let searchParams = Kadenze.Util.getURLParams(location.search);

    _.each(['types', 'sort', 'search', 'featured'], (key) => {
      self.params[key](searchParams[key]);
    });
  };

  const __construct = function(that) {
    console.log('constructor called for PeerAssignmentViewModel');
    //TODO: Pre select types and search from URL
    that.layoutMode(layoutMode);
    that.browsingScope(browsingScope);
    that.userType(userType);

    self.interceptURLParams();

    that.showPlaceholder('loading');
    that.bindFilters();

    let courses_json = $('#course_listing_json').val() || '[]';
    that.courses = ko.mapping.fromJSON(courses_json);

    let categories_json = $('#category_listing_json').val() || '[]';
    that.categories = ko.mapping.fromJSON(categories_json);

    let courseworks_json = $('#coursework_listing_json').val() || '[]';
    that.courseworks = ko.mapping.fromJSON(courseworks_json);

    if (browsingScope === 'global') {
      self.fileTypes(_.sortBy(_.uniq(_.flatten(_.map(that.courses(), function (course) { return course.file_types(); })))));
    }

    let cw = _.find(that.courseworks(), function (coursework) {
      return coursework.slug() === courseworkId;
    });

    self.params.coursework(cw);

    if (that.publicView()) {
      // disable pjax so public layout is loaded for pages in the public nav
      $(document).pjax('a[href]:not([data-remote]):not([data-behavior]):not([data-skip-pjax]):not([target="_blank"]):not([href^="javascript"])', '[data-pjax-container]', {timeout: 1});
    }
  }(this);
}
